export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3; // Radius of Earth in meters
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) *
    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c; // Distance in meters

  // Debugging output to ensure coordinates and distance
  console.log("Coordinates:");
  console.log(`lat1: ${lat1}, lon1: ${lon1}`); // Your predefined coordinates
  console.log(`lat2: ${lat2}, lon2: ${lon2}`); // Geolocation coordinates
  console.log(`Calculated Distance: ${distance.toFixed(2)} meters`);

  return distance;
};

// Function to check user's geolocation
// geolocationUtils.js
// export const getUserGeolocation = () => {
//   return new Promise((resolve, reject) => {
//     const options = {
//       enableHighAccuracy: true,  // Critical for <10m precision
//       timeout: 10000,           // 10 second timeout
//       maximumAge: 0,            // No cached positions
//     };

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         // Reject if accuracy is too poor
//         if (position.coords.accuracy > 20) { // 20m max error
//           reject(new Error(`Poor GPS accuracy (${position.coords.accuracy}m)`));
//           return;
//         }
        
//         resolve({
//           latitude: position.coords.latitude,
//           longitude: position.coords.longitude,
//           accuracy: position.coords.accuracy
//         });
//       },
//       (error) => reject(error),
//       options
//     );
//   });
// };

export const getUserGeolocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser"));
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 15000,           // 15 seconds
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        
        // Validate coordinates
        if (!isValidCoordinate(latitude, longitude)) {
          reject(new Error("Invalid coordinates received"));
          return;
        }

        resolve({
          latitude,
          longitude,
          accuracy
        });
      },
      (error) => {
        // Handle specific error codes
        let errorMessage;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = "Geolocation permission denied";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = "Location information is unavailable";
            break;
          case error.TIMEOUT:
            errorMessage = "Location request timed out";
            break;
          default:
            errorMessage = "Unknown geolocation error";
        }
        reject(new Error(errorMessage));
      },
      options
    );
  });
};

// Helper function to validate coordinates
const isValidCoordinate = (lat, lon) => {
  return (
    typeof lat === 'number' && 
    typeof lon === 'number' &&
    !isNaN(lat) && 
    !isNaN(lon) &&
    lat >= -90 &&
    lat <= 90 &&
    lon >= -180 &&
    lon <= 180
  );
};